export default "__VITE_ASSET__DXVLz5C2__"